// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"37bb473c","276":"f2b18646","391":"171f288f","418":"2b01d2ef","474":"65e75eb3","617":"1b7704a8"}[chunkId] + ".js";
};